import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '../constants/enums'

export const moderationColors = {
  pending: Colors.info,
  approved: Colors.success,
  rejected: Colors.error
}

export const moderationIcons = {
  pending: icons.schedule,
  approved: icons.done,
  rejected: icons.clear
}

export const moderationStatusIcons = {
  pending: icons.schedule,
  approved: icons.check_circle_outline,
  rejected: icons.highlight_remove
}
